/* unplugin-vue-components disabled */import { render } from "./Footer.vue?vue&type=template&id=36ccab4d&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=36ccab4d&scoped=true&lang=scss"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ccab4d"]])

export default __exports__